function TermsOfService() {
  return (
    <div>
      <iframe
        src="https://hljcreative.com/terms-conditions/"
        style={{
          width: "100%",
          height: "calc(100vh - 50px)",
        }}
      />
    </div>
  );
}

export default TermsOfService;
